<template>
  <div v-if="experiment" :class="'template-' + experiment.template_id">
    <p v-if="experiment.status === '1'">DRAFT</p>
    <screen :screen="screens[progress]"></screen>
  </div>
</template>

<script>
import Screen from './Screen'
var md5 = require('md5')

export default {
  name: 'Poll',
  components: {
    Screen
  },
  data () {
    return {
      experiment: null,
      screens: [],
      progress: 0,
      clickOrder: 1,
      screenTimeStart: +new Date(),
      variables: {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      let self = this
      var xhr = new XMLHttpRequest()
      let query = btoa(JSON.stringify(this.$route.query))
      xhr.open('GET', this.$root.apiUrl + 'v1/pollster/experiments/' + this.$route.params.id + '?bySlug=true&query=' + query)
      xhr.onload = () => {
        var response = JSON.parse(xhr.responseText)
        if (xhr.status === 200 && response.response) {
          if (!response.response.code) {
            self.$router.push({name: 'Error', params: {message: 'No data to show'}})
          }
          if (response.response.status === '1') self.$router.push({name: 'PageNotFound'})
          if (response.response.status === '4') {
            var parsedCode = JSON.parse(response.response.code)
            if(parsedCode.hasOwnProperty('messages') && parsedCode.messages.hasOwnProperty('surveyIsClosed')) {
              self.$router.push({name: 'Error', params: {message: parsedCode.messages.surveyIsClosed, css: parsedCode.style}})
            } else {
              self.$router.push({name: 'Error', params: {message: 'Survey is closed'}})
            }
          }
          self.experiment = response.response
          self.prepareCode(self.experiment.code)
          localStorage.setItem('session', md5(+new Date()))
          localStorage.removeItem('results')
        } else if (xhr.status === 403) {
          self.$router.push({name: 'Error', params: {message: 'Blocked link'}})
        } else if (xhr.status === 404) {
          self.$router.push({name: 'PageNotFound'})
        } else {
          var message
          if (response.response && response.response[0] && response.response[0].message) {
            message = response.response[0].message
          } else {
            message = 'Unknown error'
          }
          self.$router.push({name: 'Error', params: {message: message}})
        }
      }
      xhr.send()
    },
    go(skip) {
      if(skip === null || typeof skip === 'undefined') skip = 0
      this.screenTimeStart = +new Date()
      this.progress = this.progress + 1 + skip
    },
    prepareCode(code) {
      code = JSON.parse(code)
      let self = this
      let preparedScreens = []

      code.sections.forEach((section, secIndex) => {
        section.screens.forEach((screen, scrIndex) => {
          code.sections[secIndex].screens[scrIndex].sectionNum = secIndex + 1
          code.sections[secIndex].screens[scrIndex].sectionName = section.name
        })
      })

      if(code.groups && code.groups.length > 0) {
        // POGRUPOWANIE SEKCJI PO GRUPACH
        let codeSectionsTemp = JSON.parse(JSON.stringify(code.sections))
        let sectionsOrder = []
        let groupOrder = []

        // w pętli dodajemy do sekcji informacje o grupach
        codeSectionsTemp.forEach((s, si) => {
          let group = null
          let shuffleSections = null
          code.groups.forEach((g, gi) => {
            g.sections.forEach((gs, gsi) => {
              if(gs.selected === true && gsi === si) {
                group = gi
                shuffleSections = g.shuffleSections
              }
            })
          })
          s.group = group
          s.shuffleSections = shuffleSections
          sectionsOrder.push(s)
        })

        let virtualGroupsIndexes = []
        let virtualGroupsCount = 0
        let groupIndex = -1
        sectionsOrder.forEach((so, soi) => {
          let virtual = false
          // jeżeli wolna sekcja to tworzymy wirtualną grupę
          if(so.group === null) {
            virtual = true
            groupIndex++
            if(!groupOrder[groupIndex]) {
              groupOrder[groupIndex] = {
                sections: []
              }
            }
            groupOrder[groupIndex].sections.push(so)
            // tworzymy listę wirtualnych grup, żeby je tymczasowo usunąć podczas rotowania grup względem siebie
            virtualGroupsIndexes.push(groupIndex)
            virtualGroupsCount++
          } else {
            groupIndex = so.group + virtualGroupsCount
            if(!groupOrder[groupIndex]) {
              groupOrder[groupIndex] = {
                sections: []
              }
            }
            groupOrder[groupIndex].sections.push(so)
          }
        })
        // -----------------------------
        // console.log(groupOrder)
        // console.log(virtualGroupsIndexes)

        // MIESZANIE GRUP I SEKCJI
        // mieszanie grup
        if(code.groupsShuffle) {
          let groupOrderTemp = JSON.parse(JSON.stringify(groupOrder))
          // usuwamy tymczasowo wirtualne grupy
          if(virtualGroupsIndexes.length > 0) {
            let spliced = 0
            virtualGroupsIndexes.forEach((vg, vgi) => {
              groupOrderTemp.splice(vg - spliced, 1)
              spliced++
            })
          }
          // console.log(groupOrderTemp)
          // mieszamy
          groupOrderTemp = this.shuffle(groupOrderTemp)
          // przywracamy wirtualne grupy
          if(virtualGroupsIndexes.length > 0) {
            let groupOrderTemp2 = []
            let shuffledGroupIndex = 0
            let got = JSON.parse(JSON.stringify(groupOrderTemp))
            for(let i=0; i<groupOrder.length; i++) {
              if(virtualGroupsIndexes.indexOf(i) >= 0) {
                groupOrderTemp2.push(groupOrder[i])
              } else {
                groupOrderTemp2.push(got[shuffledGroupIndex])
                shuffledGroupIndex++
              }
            }
            groupOrderTemp = groupOrderTemp2
          }
          groupOrder = groupOrderTemp
        }
        // console.log(groupOrder)
        //mieszanie sekcji
        let groupOrderTemp3 = JSON.parse(JSON.stringify(groupOrder))
        groupOrderTemp3.forEach((got, goti) => {
          if(got.sections.length > 0 && got.sections[0].shuffleSections === true) groupOrder[goti].sections = this.shuffle(groupOrder[goti].sections)
        })
        // console.log(groupOrder)

        // przekształcenie grup na listę sekcji
        let newSections = []
        groupOrder.forEach((go, goi) => {
          go.sections.forEach(s => {
            newSections.push(s)
          })
        })
        code.sections = newSections
        // ---------------------------------
      }

      code.sections = this.shuffleScreens(code.sections)
      code.sections.forEach(section => {
        if (Array.isArray(section.screens)) {
          section.screens.forEach((screen, scrIndex) => {
            let iterations = 1
            let additionalHtml = screen.html
            let loop = null
            let sectionLoopScreens = []
            if (screen.loop) {
              let A = this
              var toEval = "(function() {" + screen.loop + "}())"
              try {
                loop = eval(toEval)
              }
              catch(e) {
                console.error('Error in loop ' + screen.name + ':')
                console.error(toEval)
                if (e instanceof SyntaxError) {
                  console.error(e.message)
                } else {
                  throw(e)
                }
              }
              if(loop.prepareData && typeof loop.prepareData === 'function') {
                loop.prepareData()
              }
              iterations = loop.iterations
            }
            for (let i = 0; i < iterations; i++) {
              let html = ''
              let scr = JSON.parse(JSON.stringify(screen))
              if (Array.isArray(screen.elements)) {
                screen.elements.forEach(element => {
                  let elementHtml = element.template
                  for (var option in element.options) {
                    if (loop && loop[element.hash] && loop[element.hash][option]) {
                      if(typeof loop[element.hash][option] === 'string') loop[element.hash][option] = this.getVar(loop[element.hash][option])
                      elementHtml = elementHtml.replace('@' + option + '@', loop[element.hash][option][i])
                    }
                    else
                      elementHtml = elementHtml.replace('@' + option + '@', element.options[option])
                  }
                  html += elementHtml + '<style>' + element.style + '</style>'
                })
                if (!additionalHtml) additionalHtml = ''
                if (!code.style) code.style = ''
                if (!section.style) section.style = ''
                if (!scr.style) scr.style = ''
                scr.html = html + additionalHtml + '<style>' + code.style + section.style + scr.style + '</style>'
                if (iterations > 1) {
                  if (loop.screenNames && typeof loop.screenNames === 'string') {
                    var names = this.getVar(loop.screenNames)
                    scr.name = names[i]
                  } else {
                    scr.name += '_' + i
                  }
                }
              }
              scr.loopIteration = i
              if (scrIndex === 0 && i === 0) {
                scr.scripts.before = section.scripts.before + ';' + scr.scripts.before
                if (section.screens.length === 1) {
                  scr.scripts.after = scr.scripts.after + ';' + section.scripts.after
                }
                sectionLoopScreens.push(scr)
              } else if (scrIndex === section.screens.length - 1) {
                scr.scripts.after = scr.scripts.after + ';' + section.scripts.after
                sectionLoopScreens.push(scr)
              } else {
                sectionLoopScreens.push(scr)
              }
            }
            // if (section.shuffleScreens === true) sectionLoopScreens = this.shuffle(sectionLoopScreens)
            sectionLoopScreens.forEach(sc => {
              preparedScreens.push(sc)
            })
          })
        }
      })
      self.screens = preparedScreens
    },
    setVar(name, value) {
      this.variables[name] = value
    },
    getVar(name) {
      return this.variables[name]
    },
    getScreens() {
      return this.screens
    },
    shuffleScreens(sections) {
      let shuffled = []
      let toShuffle = []
      let self = this
      sections.forEach((section, i) => {
        if (section.shuffleScreens === true) {
          sections[i].screens = self.shuffle(section.screens)
        }
        if (section.shuffle === true) {
          toShuffle.push(sections[i])
        }
      })
      toShuffle = this.shuffle(toShuffle)
      sections.forEach((section, i) => {
        if (section.shuffle === true) {
          shuffled.push(toShuffle.shift())
        } else {
          shuffled.push(sections[i])
        }
      })
      return shuffled
    },
    shuffle(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1))
        x = a[i]
        a[i] = a[j]
        a[j] = x
      }
      return a
    }
  }
}
</script>
